import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { IconModule } from '@library/ui/atoms/icon/icon.module';
import { ToolbarItemComponent } from 'src/app/toolbar/toolbar-item/toolbar-item.component';

@Component({
  selector: 'app-geolocate',
  imports: [IconModule, CommonModule, ToolbarItemComponent],
  templateUrl: './geolocate.component.html',
  styleUrl: './geolocate.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GeolocateComponent {
  geolocateObserver: MutationObserver;
  geolocateClassList = signal<string>('');

  private get geolocateUserElement(): HTMLDivElement {
    return document.querySelector('.maplibregl-control-container .maplibregl-ctrl-geolocate') as HTMLDivElement;
  }

  locateUser(): void {
    if (!this.geolocateObserver) {
      this.setObserver();
    }

    this.geolocateUserElement.click();
  }

  private setObserver(): void {
    /**
     * Observer for the geolocate button to check if the class list has changed.
     */
    this.geolocateObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          this.geolocateClassList.set(this.geolocateUserElement.classList.toString());
        }
      });
    });

    this.geolocateObserver.observe(this.geolocateUserElement, { attributes: true });
  }
}
